import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Field } from 'redux-form';
import Fields from 'components/Fields';
import { QuestionType } from 'store/modules/Quesionnare/types';
import { CustomerType } from 'store/modules/Customers/types';

const useStyles = makeStyles({
  question: {
    display: 'flex',
    fontSize: '13px',
    minHeight: '69px',
    borderBottom: '1px solid #dfdfdf',
    '&:nth-child(odd)': {
      backgroundColor: '#f9f9f9'
    }
  },
  intBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1.2rem',
    width: '54px',
    minWidth: '54px',
    backgroundColor: '#7fb847'
  },
  titleBox: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',

    padding: '1rem'
  },
  responseBox: {
    display: 'flex',
    alignItems: 'center',
    width: '290px',
    minWidth: '290px',
    maxWidth: '290px',
    borderLeft: '1px solid #dfdfdf',
    padding: '0 1rem',
    '& > div': {
      width: '100%'
    }
  },
  select: {
    width: '100%'
  }
});

interface QuestionTypeWithAnswer extends QuestionType {
  answer?: string;
}
interface Props {
  field: string;
  customers: CustomerType[];
  isJointed: boolean;
  questionData: any;
  index: number;
}

const Question = ({
  field,
  questionData,
  customers,
  isJointed,
  index
}: Props) => {
  const classes = useStyles();
  const answers = [...questionData.responses].map((answer: any) => ({
    value: answer.id,
    name: answer.text
  }));
  const isMoreThanOneCustomer = customers.length > 1;
  const filteredCustomers = customers.filter(
    (customer: CustomerType) => !customer.is_jointed
  );

  const jointedUser = customers.filter(
    (customer: CustomerType) => customer.is_jointed
  );

  const isAnswered = isMoreThanOneCustomer
    ? isJointed
      ? questionData[`user-${jointedUser[0].id}`]
      : questionData[`user-${filteredCustomers[0].id}`] &&
        questionData[`user-${filteredCustomers[1].id}`]
    : questionData[`user-${filteredCustomers[0].id}`];
  return (
    <div className={classes.question}>
      <div
        style={{ backgroundColor: isAnswered ? '#7fb847' : '#979797' }}
        className={classes.intBox}
      >
        {index + 1}
      </div>
      <div
        className={classes.titleBox}
        style={{
          flexDirection: 'column',
          alignItems: 'baseline',
          justifyContent: 'center'
        }}
      >
        {questionData.text}
        {questionData.image_url && (
          <img
            src={questionData.image_url}
            style={{
              width: '100%',
              maxWidth: '600px',
              marginTop: '1rem',
              marginBottom: '1rem'
            }}
          />
        )}
      </div>
      {isMoreThanOneCustomer ? (
        isJointed ? (
          <div className={classes.responseBox}>
            <Field
              name={`${field}.user-${jointedUser[0].id}`}
              options={answers}
              validate={Fields.Validators.required}
              component={Fields.Select}
              fullWidth
              label="Choose a response"
            />
          </div>
        ) : (
          <>
            <div className={classes.responseBox}>
              <Field
                name={`${field}.user-${filteredCustomers[0].id}`}
                options={answers}
                validate={Fields.Validators.required}
                component={Fields.Select}
                fullWidth
                label="Choose a response"
              />
            </div>
            <div className={classes.responseBox}>
              <Field
                name={`${field}.user-${filteredCustomers[1].id}`}
                options={answers}
                validate={Fields.Validators.required}
                component={Fields.Select}
                fullWidth
                label="Choose a response"
              />
            </div>
          </>
        )
      ) : (
        <div className={classes.responseBox}>
          <Field
            name={`${field}.user-${filteredCustomers[0].id}`}
            options={answers}
            validate={Fields.Validators.required}
            component={Fields.Select}
            fullWidth
            label="Choose a response"
          />
        </div>
      )}
    </div>
  );
};

export default Question;
